/**
 * promptLibrary.js — aggregates every Prompt Builder task.
 *
 * Adding a new prompt = add an object to the right prompts/<category>.js file. Nothing else to wire.
 * Later, this file can be swapped for an API call (GET /api/ai-lab/tasks) without touching components.
 */
import { PACKAGING_TASKS } from "./prompts/packaging.js";
import { BRANDING_TASKS } from "./prompts/branding.js";
import { PHOTOGRAPHY_TASKS } from "./prompts/photography.js";
import { ADVERTISING_TASKS } from "./prompts/advertising.js";
import { VIDEO_TASKS } from "./prompts/video.js";
import { SOCIAL_TASKS } from "./prompts/social.js";
import { WEBSITE_TASKS } from "./prompts/website.js";
import { RETAIL_TASKS } from "./prompts/retail.js";
import { INVESTOR_TASKS } from "./prompts/investor.js";
import { RESEARCH_TASKS } from "./prompts/research.js";
import { FINANCE_TASKS } from "./prompts/finance.js";
import { OPERATIONS_TASKS } from "./prompts/operations.js";

export const PROMPT_TASKS = [
  ...PACKAGING_TASKS,
  ...BRANDING_TASKS,
  ...PHOTOGRAPHY_TASKS,
  ...ADVERTISING_TASKS,
  ...VIDEO_TASKS,
  ...SOCIAL_TASKS,
  ...WEBSITE_TASKS,
  ...RETAIL_TASKS,
  ...INVESTOR_TASKS,
  ...RESEARCH_TASKS,
  ...FINANCE_TASKS,
  ...OPERATIONS_TASKS,
];

export const TASK_BY_ID = Object.fromEntries(PROMPT_TASKS.map((t) => [t.id, t]));

export function tasksForCategory(categoryId) {
  return PROMPT_TASKS.filter((t) => t.category === categoryId);
}

export function searchTasks(query) {
  const q = (query || "").trim().toLowerCase();
  if (!q) return PROMPT_TASKS;
  return PROMPT_TASKS.filter(
    (t) =>
      t.title.toLowerCase().includes(q) ||
      t.description.toLowerCase().includes(q) ||
      t.category.toLowerCase().includes(q)
  );
}

/** Popular tasks pinned on the dashboard / builder landing. */
export const FEATURED_TASK_IDS = [
  "packaging-concept",
  "branding-logo-direction",
  "advertising-meta-ad",
  "retail-buyer-presentation",
  "photography-studio-shot",
  "social-30-day-calendar",
  "investor-pitch-deck",
  "finance-margin-calculator",
];
